import { useEffect } from 'react';

import type { useAddPaymentDocumentsEffectsProps } from '@app/pages/PaymentDocuments/components/AddPaymentDocument/types';

export const useAddPaymentDocumentsEffects = ({
  handleSearchFilters,
  getDocument,
}: useAddPaymentDocumentsEffectsProps) => {
  useEffect(() => {
    handleSearchFilters();
  }, [handleSearchFilters]);

  useEffect(() => {
    getDocument();
  }, [getDocument]);
};
